import * as firebase from 'firebase/app';
import 'firebase/firestore';

const config = {
    apiKey: "AIzaSyBbUM-ON3wvPPppv2QyhYaR78VxACKhAso\n",
    authDomain: "seuperfilempreendedor.firebaseapp.com",
    databaseURL: "https://seuperfilempreendedor.firebaseio.com",
    projectId: "seuperfilempreendedor",
};

export default !firebase.apps.length ? firebase.initializeApp(config).firestore() : firebase.app().firestore();
